import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=58a1d8d2&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=58a1d8d2&prod&scoped=true&lang=css"
import style1 from "./detail.vue?vue&type=style&index=1&id=58a1d8d2&prod&lang=css"
import style2 from "./detail.vue?vue&type=style&index=2&id=58a1d8d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_abc276eb37b0b1314bfe9ec856cc5e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1d8d2",
  null
  
)

export default component.exports